import { render } from "./ProductCard.vue?vue&type=template&id=39b0b2b0"
import script from "./ProductCard.vue?vue&type=script&lang=ts"
export * from "./ProductCard.vue?vue&type=script&lang=ts"
script.render = render

export default script